// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '@g/utils/str'
import App from './App'
import router from './router'
import store from '@g/store'
import Vuetify from 'vuetify'
import zhHans from './locale/vuetifyZhHans'
import '@g/assets/iconfont.css'
import '@g/assets/quill.snow.css'
import '@g/assets/global.css'
import KImg from '@g/components/KImg'
import BankImage from '@g/components/BankImage'
import EventBus from '@g/components/EventBus'
import DocEvent from '@g/components/DocEvent'
import './assets/common.css'
import Snackbar from './components/Snackbar/index.js'
import filters from '../common/filters'
import Confirm from './components/Confirm'
import Countdown from '@g/components/Countdown'
import SrIcon from '@g/components/SrIcon'
import OrderTransportLabel from '@g/components/OrderTransportLabel'
import Tooltips from '@g/components/Tooltips'
import CarrierIcon from '@g/components/CarrierIcon'
import Schedule from '@g/components/Schedule'
import ContentPre from '@g/components/ContentPre.vue'
import SvgIcon from '@g/components/SvgIcon.vue'
import LoadingDown from '@g/components/LoadingDown.vue'
import WhsText from '@g/components/Text/WhsText'
import '@g/components/Text/install'
import { setDefaultHeader } from '@g/store/axiosProvider'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'
import calc from 'calculatorjs'
import dayjs from 'dayjs'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import sentryInstall, { setUser } from '@g/utils/sentryInstall'
import FullScreenLoading from '@g/components/FullScreenLoading.vue'
import Countup from '@g/components/Countup.vue'
import { reportEvent } from '@g/utils/aosAnalytics'

import './components'

document.getElementById('app').innerText = 'loading success...'

document.getElementById('app').innerText = 'mounting vue...'

Vue.prototype.$sleep = function (s) {
  return new Promise(resolve => {
    setTimeout(resolve, s)
  })
}
Vue.prototype.$openWeb = function (url) {
  window.open(url)
}
Vue.use(Vuetify)
Vue.prototype.$vuetify.lang.locales.zhHans = zhHans
Vue.prototype.$vuetify.lang.current = 'zhHans'

Vue.prototype.$calc = calc
Vue.prototype.$dayjs = dayjs
Vue.prototype.$rptEvt = reportEvent
Vue.component('SrIcon', SrIcon)
Vue.component('OrderTransportLabel', OrderTransportLabel)
Vue.component('Tooltips', Tooltips)
Vue.component('ContentPre', ContentPre)
Vue.component('SvgIcon', SvgIcon)
Vue.component('LoadingDown', LoadingDown)
Vue.component('WhsText', WhsText)
Vue.component('CarrierIcon', CarrierIcon)
Vue.component('Schedule', Schedule)
Vue.component('Countdown', Countdown)
Vue.component('KImg', KImg)
Vue.component('BankImage', BankImage)
Vue.component('EventBus', EventBus)
Vue.component('DocEvent', DocEvent)
Vue.component('DatePicker', DatePicker)
Vue.component('FullScreenLoading', FullScreenLoading)
Vue.component('Countup', Countup)
Vue.use(Viewer)
Vue.use(Snackbar, {
  mode: 'vertical',
  y: 'top'
})

Vue.use(Confirm, {
  buttonTrueText: '確定',
  buttonFalseText: '取消',
  width: 300,
  property: '$confirm'
})

filters(Vue)
Vue.filter('toCurrency', function (value, sign = '¥', decimal = 2) {
  return isNaN(value)
    ? value
    : `${sign} ` + parseFloat(value).toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
})
Vue.filter('obfuscation', function (value) {
  if (!isNaN(value)) {
    return value.replace(/\d+(\d{4})$/g, '****$1')
  }
})
Vue.filter('nl2br', function (value) {
  return value ? value.replace(/[\n\r]/g, '<br>') : ''
})
Vue.filter('comma2br', function (value) {
  return value ? value.replace(/,/g, '<br>') : ''
})

if (store.state.os.isAndroid || store.state.os.isPhone) {
  if (location.href.indexOf('www.')) { // 判断到手机端
    location.replace(location.href.replace('www.', 'm.'))
  }
}

window.countdownData = {
  currTime: Date.now()
}
setInterval(() => {
  window.countdownData.currTime = Date.now()
}, 1000)

; (async () => {
  await setDefaultHeader()
  try {
    sentryInstall({
      router,
      platform: 'pc',
      dsn: 'https://413bcf020d0e08fa72662b6f2314836b@sentry.jyb.com.tw/3'
    })
  } catch (e) {
    console.error('sentryInstall error', e)
  }
  /* eslint-disable no-new */
  /* eslint-disable */
  window.vueApp = new Vue({
    el: '#app',
    router,
    store,
    data: {
      countdownData: window.countdownData,
    },
    template: '<App/>',
    components: {
      App
    }
  })
  if (vueApp.$store.state.userData.uid) {
    setUser({
      id: vueApp.$store.state.userData.uid,
      username: vueApp.$store.state.userData.nickname,
    })
  }

  window._initSuccess = true
})()
